import { useQuery } from 'react-query';
import { AxiosResponse, AxiosError } from 'axios';
import { TRiskCategory } from '@dekafvv/sharedfrontend';
import { getSchemaListByKey, getFeatureFlags } from './migratedCalls';
import { getRiskCategories } from './portfolios';

export const getSchemaListByKeyQuery = ({ key }:{ key: string}) => {
    const query = useQuery({
        queryKey: ['getSchemaListByKey', key],
        queryFn: () => getSchemaListByKey(key),
        refetchOnWindowFocus: false,
    });

    return query;
};

export const useGetRiskCategories = ({
    refetchOnMount = true,
}: {
  refetchOnMount?: boolean;
}) => {
    const query = useQuery<
    AxiosResponse<TRiskCategory>,
    null | { message: string },
    TRiskCategory
  >({
      queryKey: ['getRiskCategories', 'shared'],
      queryFn: () => getRiskCategories().then(({ data }) => data),
      refetchOnWindowFocus: false,
      refetchOnMount,
  });

    return query;
};

export const useGetFeatureFlags = ({
    key,
    refetchOnMount = true,
}: {
  key: string;
  refetchOnMount?: boolean;
}) => {
    const query = useQuery<
  TGetFeatureFlagsResponse,
  AxiosError,
  TGetFeatureFlagsResponse
>({
    queryKey: ['getFeatureFlags', key],
    queryFn: () => getFeatureFlags(key).then(({ data }) => data),
    refetchOnWindowFocus: false,
    retry: false,
    refetchOnMount,
});

    return query;
};

type TGetFeatureFlagsResponse = {
  Key: string;
  Value: string;
  Group: string;
}
